/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3945 Freedom Circle, Suite 730 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from 'react-error-boundary'

import { WidgetLoadingGuard } from '../share/guards'
import CustomVizWidgetDataEffect from './CustomVizWidgetDataEffect'
import CustomVisualization from './CustomVisualization'
import PlaceHolder from '../../share/PlaceHolder'

const CustomVisualizationWidget = ({ widgetId }) => {
  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <CustomVizWidgetDataEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <CustomVisualization widgetId={widgetId} />
        </WidgetLoadingGuard>
      </CustomVizWidgetDataEffect>
    </ErrorBoundary>
  )
}

CustomVisualizationWidget.propTypes = {
  widgetId: PropTypes.number.isRequired
}

export default CustomVisualizationWidget
